import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class WorkstationService {
  addWorkstation(modal) {
    return api.post(
      UtilsUrl.productionURL() + "/workstations/addWorkstation",
      modal
    );
  }
  updateWorkstation(modal) {
    return api.post(
      UtilsUrl.productionURL() + "/workstations/updateWorkstation",
      modal
    );
  }
  allWorkstations(idUser) {
    return api.get(
      UtilsUrl.productionURL() + "/workstations/allWorkstations/" + idUser
    );
  }
  getWorkOrdersByWorkStation(idUser,idWorkstation,dateBegin,dateEnd) {
    return api.get(
      UtilsUrl.productionURL() + "/production-orders/getWorkOrdersByWorkStation/" + idUser+"/"+idWorkstation+"/"+dateBegin+"/"+dateEnd
    );
  }
  getWorkstationsById(id) {
    return api.get(
      UtilsUrl.productionURL() + "/workstations/getWorkstationsById/" + id
    );
  }
  allDepartement(idUser) {
    return api.get(
      UtilsUrl.productionURL() + "/workstations/allWorkstations/" + idUser
    );
  }
  allDepts(id) {
    return api.get(
      UtilsUrl.productionURL() + "/workstations/allDepts/" + id
    );
  }
}

export default new WorkstationService();
